import { useNavigate } from 'react-router-dom';
import { BusinessStatus } from '@/types/schema/commonSchema';

export const useBusinessCardNavigation = () => {
  const navigate = useNavigate();
  
  const handleBusinessClick = (
    e: React.MouseEvent, 
    businessId: string, 
    status: BusinessStatus,
    businessPackage?: string
  ) => {
    e.preventDefault();
    e.stopPropagation();
    
    console.log(`BusinessCard clicked for business: ${businessId} with status: ${status}, package: ${businessPackage}`);
    
    // Navigate based on business status
    if (status === 'onboarding') {
      // If business has a package selected, navigate to step 1 directly
      if (businessPackage) {
        navigate(`/business/${businessId}/gocampaign?step=1`);
      } else {
        // Otherwise navigate to step 0 to select a package first
        navigate(`/business/${businessId}/gocampaign`);
      }
    } else {
      // For active, paused businesses, go to details page
      navigate(`/business/${businessId}`);
    }
  };

  return { handleBusinessClick };
};
